module.exports = __webpack_public_path__ + "static/img/6816_phase_function_Paper_Points.37a9b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6816_phase_function_Paper_Points.png
// module id = QcrT
// module chunks = 0